import { z } from 'zod';

/**
 * Payload of `GET /api/version`. Carries the deploy's `git describe` output, e.g.
 * `2026.33.alpha-0-g4fc25490b`. Browser tabs compare it against `window.__BUILD_VERSION__`
 * to notice that a newer frontend has been rolled out under them.
 *
 * Compared by exact string equality, so the format can change without touching any consumer.
 */
export const VersionSchema = z.object({
  version: z.string(),
});

export type Version = z.infer<typeof VersionSchema>;
